import { EmailFilterPropertyNames } from "../../../features/Library/Communications/Emails/types/state";
import { type FilterItemBase } from "../FilterFormBuilder/FilterFormBuilder";
import { FilterViewTypes } from "../../../enums/filterViewTypes";

export const getEmailFilters = (includePublisher: boolean = true): FilterItemBase<EmailFilterPropertyNames>[] => {
  const filters: FilterItemBase<EmailFilterPropertyNames>[] = [
    {
      type: FilterViewTypes.DateRange,
      label: "Date Added",
      propertyName: EmailFilterPropertyNames.DateCreated,
    },
    {
      type: FilterViewTypes.DateRange,
      label: "Last Modified",
      propertyName: EmailFilterPropertyNames.DateModified,
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Packs",
      propertyName: EmailFilterPropertyNames.Packs,
      placeholder: "All Packs",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Software Applications",
      propertyName: EmailFilterPropertyNames.SoftwareApplications,
      placeholder: "All Applications",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Labels",
      propertyName: EmailFilterPropertyNames.Labels,
      placeholder: "All Labels",
    },
  ];

  if (includePublisher) {
    filters.push({
      type: FilterViewTypes.MultiSelect,
      label: "Publisher",
      propertyName: EmailFilterPropertyNames.Publishers,
      placeholder: "All Publishers",
    });
  }

  return filters;
};
